(() => {
  if (window.__copiremaCartReady) return;
  window.__copiremaCartReady = true;

  const orderThesisLines = () => {
    document.querySelectorAll('tbody, ul.mini-cart__navigation').forEach((container) => {
      const lines = [...container.children].filter((line) => line.dataset.copiremaJob);
      const jobs = [...new Set(lines.map((line) => line.dataset.copiremaJob))];
      jobs.forEach((job) => {
        const jobLines = lines.filter((line) => line.dataset.copiremaJob === job);
        if (jobLines.length < 2) return;
        const ordered = [...jobLines].sort((a, b) => {
          const rank = { cover: 0, bw: 1, color: 2 };
          return (rank[a.dataset.copiremaLineType] ?? 3) - (rank[b.dataset.copiremaLineType] ?? 3);
        });
        if (jobLines.every((line, index) => line === ordered[index])) return;
        const insertionPoint = jobLines[jobLines.length - 1].nextSibling;
        ordered.forEach((line) => container.insertBefore(line, insertionPoint));
      });
    });
  };

  orderThesisLines();
  document.addEventListener('shopify:section:load', orderThesisLines);

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-copirema-clear-cart]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const originalLabel = button.textContent;
    button.textContent = 'Svuotamento in corso…';
    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(window.routes?.cart_clear_url || `${root}cart/clear.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Svuotamento non riuscito');
      window.location.assign(window.routes?.cart_url || `${root}cart`);
    } catch (error) {
      console.error(error);
      button.textContent = originalLabel;
      window.location.assign(button.href || `${root}cart/clear`);
    }
  });
})();
